import React, { useState, useEffect, FC } from 'react'
import { Table, Select, Input } from 'antd'
import { YhBox } from '@/components/YhBox'
import { RouterParamType } from '@/model/navModel'
import { ColumnsType } from 'antd/lib/table'
import YhTootip from '@/components/YhTootip'
import YhDebounceSelect from '@/components/YhDounceSelect'
import useGlobalModel from '@/model/globalModel'
import { ISelectOption } from '@/components/YhFormBox/Types'
import { IInquiryGoodsForContrast } from '@/views/inquiry/inquiryTypes'
import { IInquiryResultDetailItem } from './inquiryResultDetail'
export const Mavb: FC<RouterParamType & { data: IInquiryResultDetailItem}> = ({ data }) => {
    const columns: ColumnsType<IInquiryGoodsForContrast> = [
        {
            title: '序号',
            width: 40,
            align: 'left',
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '商品名称',
            width: 200,
            align: 'left',
            dataIndex: 'materialName',
            render: (text: string) => <YhTootip style={{ width: '100%' }} text={text} />,
        },

        {
            title: '商品编号',
            width: 180,
            align: 'left',
            dataIndex: 'materialCode',
            render: (text: string) => <YhTootip text={text} />,
        },
        // {
        //     title: '品牌',
        //     width: 100,
        //     align: 'left',
        //     dataIndex: 'brandName',
        //     render: (text: string) => <YhTootip text={text} />,
        // },
        // {
        //     title: '单位',
        //     width: 100,
        //     align: 'left',
        //     dataIndex: 'unitName',
        //     render: (text: string) => <YhTootip text={text} />,
        // },
        {
            title: '单价',
            width: 100,
            align: 'left',
            fixed: 'right',
            dataIndex: 'price',
            render: (text: string) => <YhTootip text={text} />,
        },
       
    ]

    return (
        <div style={{ margin: '10px', width: 'calc((100vw - 285px) / 3)' }}>
            <YhBox>
                <div style={{ display: 'flex', padding: '0 10px 10px 10px' }}>
                    <Input
                       style={{ flex: 1, marginRight: '10px' }}
                        className="border-r-16"
                        placeholder="供应商"
                        value={data.supplierName}
                        disabled
                    />
                    <Input
                        style={{ flex: 1 }}
                        className="border-r-16"
                        placeholder="询价单号"
                        value={data.code}
                        disabled
                    />
                </div>
                <Table
                    style={{ width: 'calc((100vw - 285px) / 3)', minHeight:"680px" }}
                    rowKey={(record) => record.id}
                    columns={columns}
                    dataSource={data.list || []}
                    pagination={false}
                    scroll={{ x: 'max-content' , y: '640px'}}
                    locale={{
                        emptyText: (
                            <div style={{ minHeight: '600px', textAlign: 'center', lineHeight: '600px' }}>
                                暂无数据
                            </div>
                        ),
                    }}
                />
            </YhBox>
        </div>
    )
}
